import React from "react";
import HeaderAdmin from "./HeaderAdmin";
import Sidebaar from "./user/Sidebaar";

const Layout = ({ children }) => {
  return (
    <>
      <HeaderAdmin />
      <Sidebaar />
      {children}
    </>
  );
};

export default Layout;
